import React from "react";
import CustomButton from "./CustomButton";

const VitalityCard = (props) => {
  const { psTitle, texts, onClick, showButton = true } = props;

  return (
    <div className="flex justify-center items-center px-4 pt-6">
      <div className="max-w-4xl w-full md:px-6 px-0">
        <div
          className="bg-[#EFF6FF] md:px-12 px-6 py-8 rounded-lg shadow-md flex flex-col md:flex-row relative"
          style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
        >
          <div className="w-full pr-4 space-y-4 text-gray-800 text-start text-[20px]">
            <p className="text-center underline font-bold text-[20px] bold-font">
              {psTitle}
            </p>
            {texts.map((item, index) => (
              <p key={index} className={item.center ? "text-center" : ""}>
                {item.text}
              </p>
            ))}
            {showButton && (
              <div className="w-full flex justify-center items-center">
                <CustomButton
                  title="Yes! I Want My Free Vitality Box"
                  onClick={onClick}
                />
              </div>
            )}
            <div className="flex text-center justify-center mb-6">
              <img src="https://cdn.blackincae.com/TuJ-cards-l.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VitalityCard;
